import { TranslateModule } from '@ngx-translate/core';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

import { MwArrowTogglerModule } from '../../../@shared/@components/arrow-toggler/arrow-toggler.module';
import { MwNavListComponent } from './nav-list.component';
import { MwNavListService } from './nav-list.service';

@NgModule({
  declarations: [MwNavListComponent],
  exports: [MwNavListComponent],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    MatIconModule,
    MwArrowTogglerModule,
  ],
  providers: [MwNavListService],
})
export class MwNavListModule {}
